'use client';
import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import {
  type DynamicFilterMessages,
  dynamicFilterMessagesAtom,
} from '@plp/Atoms/DynamicFilterMessagesAtom';
import { filterUpdateStartedAtom } from '@plp/Atoms/FilterUpdateStarted';

type Props = {
  filtersList: Filter[];
  strings: DynamicFilterMessages;
};

export const ClientTasks = ({ filtersList, strings }: Props) => {
  const setFilterUpdateStarted = useSetAtom(filterUpdateStartedAtom);
  const setDynamicFilterMessages = useSetAtom(dynamicFilterMessagesAtom);
  const setFiltersList = useSetAtom(filtersListAtom);
  const filtersStr = JSON.stringify(filtersList);

  useEffect(() => {
    setFilterUpdateStarted(false);
  }, [filtersStr]);

  useEffect(() => {
    setDynamicFilterMessages(strings);
    setFiltersList(filtersList);
  }, [filtersList, JSON.stringify(strings)]);

  return undefined;
};
